module.exports = __webpack_public_path__ + "static/img/bg-cuna-sportswear.3a00197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-cuna-sportswear.png
// module id = IBZy
// module chunks = 0